import SettingsIcon from '@mui/icons-material/Settings';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { useHasPermission } from '../../auth';
import { Routes } from '../../routes/routes';

/**
 * «Раздел выключен» — the empty state a «Площадка» list, tab or card shows on
 * 404 `not_found` (feature flag off; see `isSectionDisabledError`). With
 * `manage_settings` it links to `/config`, without it — no link (mockup
 * `section-off` / `section-off-config`).
 */
const SectionDisabledInner = (): ReactElement => {
  const { t } = useTranslation();
  const canConfigure = useHasPermission('manage_settings');

  return (
    <Box
      data-testid="sm-section-disabled"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, py: 6 }}
    >
      <VisibilityOffIcon sx={{ color: 'text.secondary', fontSize: 32 }} />
      <Typography variant="subtitle1">{t('marketplace.sectionDisabled.title')}</Typography>
      {canConfigure ? (
        <Button
          component={RouterLink}
          to={Routes.App.Config}
          variant="outlined"
          startIcon={<SettingsIcon />}
          data-testid="sm-open-config"
        >
          {t('marketplace.sectionDisabled.openConfig')}
        </Button>
      ) : null}
    </Box>
  );
};

export const SectionDisabled = observer(SectionDisabledInner);
